import SspForm from 'common/pages/ssp/SspForm.tsx'

export const SspFormAdmin = (props: any) => <SspForm {...props} mode={props.mode} admin />